import { CURRENCY_FORMAT } from "@redotech/redo-web/currency";
import * as React from "react";

export const FlexibleCheckoutButtons = ({
  onClickCoverage,
  onClickNoCoverage,
  isCoverage,
  dataTarget,
  coveragePrice,
  cartTotal,
  cartTotalPreDiscount,
  html,
  customCss,
  currency,
}: {
  onClickCoverage: (event: React.MouseEvent) => void;
  onClickNoCoverage: (event: React.MouseEvent) => void;
  isCoverage: boolean;
  dataTarget?: string;
  coveragePrice: number;
  cartTotal: number;
  cartTotalPreDiscount: number;
  html: string;
  customCss?: string;
  currency?: string;
}) => {
  // replace html here then place.

  html = html.replaceAll(
    "%price%",
    CURRENCY_FORMAT(currency || "USD").format(coveragePrice),
  );
  html = html.replaceAll(
    "%cartTotal%",
    CURRENCY_FORMAT(currency || "USD").format(cartTotal),
  );
  html = html.replaceAll(
    "%combinedPrice%",
    CURRENCY_FORMAT(currency || "USD").format(coveragePrice + cartTotal),
  );
  html = html.replaceAll(
    "%cartTotalPreDiscount%",
    CURRENCY_FORMAT(currency || "USD").format(cartTotalPreDiscount),
  );
  html = html.replaceAll(
    "%combinedPricePreDiscount%",
    CURRENCY_FORMAT(currency || "USD").format(
      cartTotalPreDiscount + coveragePrice,
    ),
  );
  return (
    <>
      {customCss ? <style>{customCss}</style> : null}
      <div
        dangerouslySetInnerHTML={{ __html: html }}
        data-target={`${dataTarget || (isCoverage ? "coverage-button" : "non-coverage-button")}`}
        onClick={isCoverage ? onClickCoverage : onClickNoCoverage}
      />
    </>
  );
};
